import React, { useContext, useState } from 'react';
import {
  Box,
  Heading,
  Text,
  Textarea,
  Button,
  useToast,
} from '@chakra-ui/react';
import { useStepperContext } from '../../contexts/StepperContext';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const Mim = (props) => {
  const { userData, setUserData } = useStepperContext();
  const toast = useToast();

  const orderId = props.orderId;

  const handleChange = (event) => {
    const { name, value } = event.target;

    const wordCount = value.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount <= maxWordCount) {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: value }));
    } else {
      const truncatedValue = value
        .trim()
        .split(/\s+/)
        .slice(0, maxWordCount)
        .join(' ');

      setUserData((prevUserData) => ({
        ...prevUserData,
        [name]: truncatedValue,
      }));

      alert(
        `Word limit exceeded. Please limit your response to ${maxWordCount} words.`,
      );
    }
  };

  const handleTextareaChange = (event, name) => {
    const inputValue = event.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount > maxWordCount) {
      toast({
        title: 'Word Limit Exceeded',
        description: `Please limit your input to ${maxWordCount} words.`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } else {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: inputValue }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = {
      question1: userData.s1 || '',
      question2: userData.s2 || '',
      question3: userData.s3 || '',
      question4: userData.s4 || '',
      question5 : userData.s5 || '',
      question6 : userData.s6 || '',
      question7 : userData.s7 || '',
      question8 : userData.s8 || '',
      question9 : userData.s9 || '',
      question10 : userData.s10 || '',
      question11 : userData.s11 || '',
      question12 : userData.s12 || '',
      question13 : userData.s13 || '',
      question14 : userData.s14 || '',
      question15 : userData.s15 || '',
      question16 : userData.s16 || '',
      question17 : userData.s17 || '',
      question18 : userData.s18 || '',
      question19 : userData.s19 || '',
      question20 : userData.s20 || '',
      // follow on questions
    };
    try{
    const response = await axios.put('https://glb-api.onrender.com/appforms/apform4',{userData:formData, orderId:orderId, name:"Custom"}, {withCredentials:true});
    console.log(response);
    setUserData({});
    toast({
      title: 'Form Submitted',
      description: 'Your data has been submitted successfully.',
      status: 'success',
      duration: 5000,
      isClosable: true,
    });
  } catch (error) {
    console.error(error);
    toast({
      title: 'Error',
      description: 'An error occurred while submitting the form.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  }
};

  const getMaxWordCount = (name) => {
    // Add your logic to determine the max word count based on the name of the textarea
    // For example:
    switch (name) {
      case 's1':
        return 105;
      case 's2':
        return 400;
      case 's3':
        return 250;
      case 's4':
        return 250;
      case 's5':
        return 500;
      case 's6':
        return 300;
      case 's7':
        return 250;
      case 's10':
        return 400;
      case 's11':
        return 300;
      case 's12':
        return 300;
      case 's13':
        return 400;
      case 's14':
        return 300;


      case 's17':
        return 100;


      default:
        return 1200;
    }
  };

  return (
    <Box mx="auto" mt="4">
      <Heading as="h1" size="xl" mb="4">
        Application Form 3
      </Heading>
      <form onSubmit={handleSubmit}>
        <Box mb="10">
          <Text p="5">
            1. Describe yourself or introduce yourself to your MBA class. 105
            words
          </Text>
          <Textarea
            name="s1"
            value={userData.s1 || ''}
            onChange={(event) => handleTextareaChange(event, 's1')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
            2. Why MBA/Business Masters degree and what this education will give
            you. Which concentration in masters and why or what makes you a fit
            for that concentration, what skills you carry to see it as a fit
            (400 words max). It is important to understand your planned career
            trajectory. Use this space also to explain if your masters degree is
            a career-switch or it is an altogether different degree. How can we
            show a story to make it a case.
          </Text>
          <Textarea
            name="s2"
            value={userData.s2 || ''}
            onChange={(event) => handleTextareaChange(event, 's2')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
            3. Immediate Post MBA plan (mention role, possible recruiters and
            geographical focus (if you want to) (250words max)
          </Text>
          <Textarea
            name="s3"
            value={userData.s3 || ''}
            onChange={(event) => handleTextareaChange(event, 's3')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            4. What is your long-term career goal (5-10 years down the line) 250
            words{' '}
          </Text>
          <Textarea
            name="s4"
            value={userData.s4 || ''}
            onChange={(event) => handleTextareaChange(event, 's4')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            5. Describe your work experience/Internships/key experiences in
            chronological order, if applicable (500 words max)
          </Text>
          <Textarea
            name="s5"
            value={userData.s5 || ''}
            onChange={(event) => handleTextareaChange(event, 's5')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            6. Any professional stint done at an international location. 300
            words
          </Text>
          <Textarea
            name="s6"
            value={userData.s6 || ''}
            onChange={(event) => handleTextareaChange(event, 's6')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            7. Describe your greatest professional accomplishment and why do you
            view it as such. 250 words
          </Text>
          <Textarea
            name="s7"
            value={userData.s7 || ''}
            onChange={(event) => handleTextareaChange(event, 's7')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            8. Describe a professional failure or instance you felt short of
            expectations and how it impacted you or what you learned from it.{' '}
          </Text>
          <Textarea
            name="s8"
            value={userData.s8 || ''}
            onChange={(event) => handleTextareaChange(event, 's8')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">9. Any research papers/work/patents. Elaborate</Text>
          <Textarea
            name="s9"
            value={userData.s9 || ''}
            onChange={(event) => handleTextareaChange(event, 's9')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            10. Mention 3 to 5 activities/hobbies you are passionate about. What
            meaning they add to your life and how it impacts people around you.
            (300-400 words max)
          </Text>
          <Textarea
            name="s10"
            value={userData.s10 || ''}
            onChange={(event) => handleTextareaChange(event, 's10')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            11. How you see your future career adding value to the society. (300
            words)
          </Text>
          <Textarea
            name="s11"
            value={userData.s11 || ''}
            onChange={(event) => handleTextareaChange(event, 's11')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            12. What traits differentiates you as a person from your peers. (300
            words max)
          </Text>
          <Textarea
            name="s12"
            value={userData.s12 || ''}
            onChange={(event) => handleTextareaChange(event, 's12')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            13. Describe your professional achievements (Any three) 300-400
            words. How these achievements stood out in terms of impact on the
            organization.
          </Text>
          <Textarea
            name="s13"
            value={userData.s13 || ''}
            onChange={(event) => handleTextareaChange(event, 's13')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            14. What have most noteworthy extracurricular achievements/community
            activities. (school/college/professional). 300 words max
          </Text>
          <Textarea
            name="s14"
            value={userData.s14 || ''}
            onChange={(event) => handleTextareaChange(event, 's14')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">15. Which newspaper do you read, if any? ?</Text>
          <Textarea
            name="s15"
            value={userData.s15 || ''}
            onChange={(event) => handleTextareaChange(event, 's15')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            16. What do you want to be known for in your social circle or in
            society, once you have a comfortable income and savings?
          </Text>
          <Textarea
            name="s16"
            value={userData.s16 || ''}
            onChange={(event) => handleTextareaChange(event, 's16')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            17. Is there any public figure, currently or in the past, that has
            moved something in you? If yes, what aspect moved you? (100 words)
          </Text>
          <Textarea
            name="s17"
            value={userData.s17 || ''}
            onChange={(event) => handleTextareaChange(event, 's17')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            18. What was the last book (other than course work) you read? Do you
            have any impressions you would like to share?
          </Text>
          <Textarea
            name="s18"
            value={userData.s18 || ''}
            onChange={(event) => handleTextareaChange(event, 's18')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            19. How would you contribute to the university/college/department
            community in a way that you would be proud of?
          </Text>
          <Textarea
            name="s19"
            value={userData.s19 || ''}
            onChange={(event) => handleTextareaChange(event, 's19')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
            20. Is there anything else you would like to share that has not been
            covered yet? This can include personal incidents, moments in
            history, or any other aspects of your life.
          </Text>
          <Textarea
            name="s20"
            value={userData.s20 || ''}
            onChange={(event) => handleTextareaChange(event, 's20')}
            placeholder="Your answer"
          />
        </Box>

        <Button type="submit" colorScheme="blue">
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default Mim;
